import React from "react";
import { Button } from "../../../Components/Forms";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { connect } from "react-redux";
import NaijaStates from "naija-state-local-government";
import RateRanger from "./RateRanger";
import CommunicationFilter from "./CommunicationFilter";
import { updateSearchParameters, updateSearchResults } from "../../../Redux/SearchEngine/actions";

const animatedComponents = makeAnimated();

const SideBarSearchFilter = ({ categories = [], updateSearchResults, updateSearchParameters, searching, expandMobileSearch, setExpandMobileSearch }) => {
    const categoriesFormated = categories.map((e) => {
        return { value: e.id, label: e.title };
    })
	const pickCategory = React.useRef(null);
	const pickState = React.useRef(null);
	const pickLga = React.useRef(null);
	const keyword = React.useRef(null);
	const ranger = React.useRef(null);
	const modeofcomms = React.useRef(null);
	const pickGender = React.useRef(null);

	const [category, setCategory] = React.useState([]);
	const [state, setState] = React.useState({
		label: "Anambra",
		value: "Anambra",
	});
	const [lgas, setLgas] = React.useState([]);
	const [searchKeyword, setSearchKeyword] = React.useState();
	const [gender, setGender] = React.useState();

	const clearAll = () => {
		pickCategory?.current && pickCategory.current.clearValue();
		pickState?.current && pickState.current?.clearValue();
		pickLga?.current && pickLga.current?.clearValue();
		pickGender?.current && pickGender.current?.clearValue();
		clearKeyword();
	};

	const clearKeyword = () => {
		keyword.current.value = "";
		setSearchKeyword();
		ranger.current.reset();
		modeofcomms.current.reset();
	};

    const updateSearchParams = () => {
        const values = {
			categories: category?.map((e) => { return e.value }),
			state: state?.label,
			lgas: lgas.map((e) => { return e.label }),
			searchKeyword,
			range: ranger.current?.getValues(),
			communications: modeofcomms.current?.getValues(),
            gender: gender?.value
		};
        updateSearchParameters(values);
        updateSearchResults();
		setExpandMobileSearch(!expandMobileSearch);
    }
    

	return (
		<div className="card filter-box">
			<div
				className="header p-5"
				style={{
					borderBottom: "1px solid #f4f4f4",
					display: "flex",
					justifyContent: "space-between",
				}}
			>
				<h2 style={{ fontWeight: 600 }}>Advance Search</h2>
                {/* expandMobileSearch, setExpandMobileSearch */}
				<button onClick={() => setExpandMobileSearch(!expandMobileSearch)} className="clear-button search-close-button">
					Close
				</button>
				<button onClick={clearAll} className="clear-button search-close-alt">
					Clear
				</button>
			</div>
			<div className="content p-5">
				<div>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: 10,
						}}
					>
						<h6 style={{ fontWeight: 600, margin: 0 }}>Keyword</h6>
						<button onClick={clearKeyword} className="clear-button">
							Clear
						</button>
					</div>
					<input
						ref={keyword}
						className="input"
						onInput={(e) => setSearchKeyword(e.target.value)}
						type="text"
						placeholder="Enter keyword"
					></input>
				</div>
				<div className="mt-5">
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: 10,
						}}
					>
						<h6 style={{ fontWeight: 600, margin: 0 }}>Categories</h6>
						<button
							onClick={() => pickCategory.current.clearValue()}
							className="clear-button"
						>
							Clear
						</button>
					</div>
					<Select
						ref={pickCategory}
						closeMenuOnSelect={true}
						isClearable={false}
						components={animatedComponents}
						isMulti
                        // defaultValue={categoriesFormated}
						options={categoriesFormated}
						onChange={(e) => setCategory(e)}
					/>
				</div>

				<div className="mt-5">
					<div
						className=""
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: 10,
						}}
					>
						<h6 style={{ fontWeight: 600, margin: 0 }}>Location</h6>
						<button
							onClick={() => {
								pickState?.current && pickState.current?.clearValue();
								pickLga?.current && pickLga.current?.clearValue();
							}}
							className="clear-button"
						>
							Clear
						</button>
					</div>
					<Select
						ref={pickState}
						closeMenuOnSelect={true}
						isClearable={false}
						components={animatedComponents}
						// isMulti
						value={state}
						options={NaijaStates.all().map((e) => {
							return { value: e.lgas, label: e.state };
						})}
						onChange={(e) => {
							setState(e);
							setTimeout(
								() => {
									if (pickLga?.current) {
										pickLga.current?.setValue(
											e.value.map((e) => {
												return { value: e, label: e };
											}),
										);
									}
								},
								pickLga?.current ? 0 : 100,
							);
						}}
					/>
				</div>

                <div className="mt-5">
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: 10,
						}}
					>
						<h6 style={{ fontWeight: 600, margin: 0 }}>Gender</h6>
						<button
							onClick={() => pickGender.current.clearValue()}
							className="clear-button"
						>
							Clear
						</button>
					</div>
					<Select
						ref={pickGender}
						closeMenuOnSelect={true}
						isClearable={false}
						components={animatedComponents}
						options={[
                            // { value: "ALL", label: "Both Gender" },
                            { value: "MALE", label: "Male Doctors" },
                            { value: "FEMALE", label: "Female Doctors" },
                        ]}
						onChange={(e) => setGender(e)}
					/>
				</div>


				<div className="mt-5">
					<RateRanger ref={ranger} />
				</div>
				<div className="mt-5">
					<CommunicationFilter ref={modeofcomms} />
				</div>
			</div>
			<div className="bottom p-5" style={{ borderTop: "1px solid #f4f4f4" }}>
				<Button 
					loading={searching} text="Search" 
					callback={updateSearchParams} 
				/>
			</div>
		</div>
	);
};

const mapStateToProps = ({ categories }) => {
	return { categories: categories.allcategories };
};

const mapDispatchToProps = (dispatch) => {
	return {
        updateSearchResults: (e) => dispatch(updateSearchResults(e)),
        updateSearchParameters: (e) => dispatch(updateSearchParameters(e))
    };
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(SideBarSearchFilter);
